/**
 * Бургер-меню: открытие/закрытие по клику на burger__btn,
 * закрытие при клике вне меню (на внешнюю область).
 * Работает при экране ≤1094px, когда меню скрыто (display: none).
 */
export const burgerMenu = () => {
  const burger = document.querySelector('.burger__btn');
  const menu = document.querySelector('.menu');

  if (!burger || !menu) return;

  const openMenu = () => {
    menu.classList.add('menu--open');
    document.body.classList.add('open--menu');
  };

  const closeMenu = () => {
    menu.classList.remove('menu--open');
    document.body.classList.remove('open--menu');
  };

  const toggleMenu = () => {
    menu.classList.toggle('menu--open');
    document.body.classList.toggle('open--menu');
  };

  // Клик по бургеру — открыть/закрыть
  burger.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleMenu();
  });

  // Клик вне меню (и не по бургеру) — закрыть
  document.addEventListener('click', (e) => {
    if (!menu.classList.contains('menu--open')) return;
    if (e.target.closest('.menu') || e.target.closest('.burger__btn')) return;
    closeMenu();
  });

  // Закрытие по Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMenu();
  });
};
